import type { CartAddressData } from 'services/types';
import type { LocaleIso } from 'utils';
import { isAddressCountrySupportedForLocale } from './isAddressCountrySupportedForLocale';
import { isAddressCompleteForLocale } from './isAddressCompleteForLocale';

/** Returns whether an address is complete and country-compatible for the locale. */
export function isAddressUsableForLocale(address: CartAddressData | undefined, locale: LocaleIso): boolean {
  return (
    isAddressCountrySupportedForLocale(address?.country, locale) && isAddressCompleteForLocale(address, locale)
  );
}